import { CheckCircleOutlineRounded, ChevronRight, ExpandMore, RadioButtonUncheckedOutlined } from '@mui/icons-material'
import { Box, Checkbox, FormControl, FormControlLabel } from '@mui/material'
import { TreeItem, TreeView } from '@mui/x-tree-view'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import SubtitleGrey from '../../../../../../shared/styles/SubtitleGrey'

interface MenusUserInfoProps {
  handleClickAccessMenu: any
}

export function MenusUserInfo({ handleClickAccessMenu }: MenusUserInfoProps) {
  const { t } = useTranslation(['global'])

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  return (
    <Box pb={1}>
      <FormControl fullWidth style={{ marginBottom: 0 }}>
        <TreeView defaultCollapseIcon={<ExpandMore />} defaultExpandIcon={<ChevronRight />} multiSelect>
          <TreeItem
            nodeId="1"
            label={
              <SubtitleGrey variant="body1" style={{ height: 40, display: 'flex', alignItems: 'center' }}>
                {t('restrict-access')}
              </SubtitleGrey>
            }
          >
            {authUser.menus.map((menu: any) => (
              <FormControlLabel
                key={menu.id}
                control={
                  <Checkbox
                    size="small"
                    color="default"
                    icon={<RadioButtonUncheckedOutlined fontSize="small" />}
                    checkedIcon={<CheckCircleOutlineRounded fontSize="small" />}
                    onChange={handleClickAccessMenu(menu.id)}
                    checked={userProfileSelected.menusIds.includes(menu.id)}
                    name={`${menu.name}`}
                  />
                }
                label={t(`${menu.code}`)}
                style={{ width: '100%' }}
              />
            ))}
          </TreeItem>
        </TreeView>
      </FormControl>
    </Box>
  )
}
